import { Component } from '@angular/core';

import { NearbyPage } from '../nearby/nearby';
import { SearchPage } from '../search/search';
import { FavoritesPage } from '../favorites/favorites';
import { HomePage } from '../home/home';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tabHome = HomePage;
  tabNearby = NearbyPage;
  tabSearch = SearchPage;
  tabFavorites = FavoritesPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts